<p-toast></p-toast>
<div class="app-verification-container">
    <p-card styleClass="p-card-shadow" class="">
        <div class="card dashboardTable">
            <p-table #tankTable [value]="tankData" [(selection)]="filteredDataForExport" dataKey="Scheme_Specific_Id"
            (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)" (onHeaderCheckboxToggle)="onHeaderCheckboxToggle($event)"
             [globalFilterFields]="[ 
             'Scheme_Specific_Id', 
             'Farmer_Name_In_English',
             'Gender' , 
             'Address_Line_1',  
             'Address_Line_2', 
             'Address_Line_3', 
             'District',
             'State', 
             'Country',
             'Farmer_Bank_Name',
             'Farmer_IFSCCode',
             'Farmer_Account_Number',
             'Aadhar_Number',
             'Pincode',
             'Center_Share_Payment_Amount',
             'State_Share_Payment_Amount',
             'FinYear',
             'ApplicantType',
             'UserType',
             'Coverage_Area',
             'TopUp',
             'ABY',
             'Caste_Description'
             ]" responsiveLayout="scroll" [rowHover]="true" currentPageReportTemplate="{{'SHOWING'| translate}} {first} {{'TO'| translate}} {last} {{'OF'| translate}} {totalRecords} {{'ENTRIES'| translate}}"
             [showCurrentPageReport]="true" [paginator]="true" [rows]="10" [selectionPageOnly]="true" [rowsPerPageOptions]="[10,25,50,100,500,1000,1500,3000,5000]" [loading]="loading">
                <ng-template pTemplate="caption">
                    <div class="flex align-items-center justify-content-between">
                        <h5 class="m-0">{{'LIST_OF_WATER_TANK_TO_BE_VERIFIED_(PFMS_MODULE)'| translate}}</h5>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text"
                                (input)="tankTable.filterGlobal($any($event.target).value, 'contains')"
                                placeholder="{{'SEARCH'| translate}}" />
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header">
                    <tr>
                        <th style="width: 3rem">
                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                        </th>
                        <th pSortableColumn="">{{'VIEW_APPLICATION'| translate}}</th> 

                        <th pSortableColumn="Scheme_Specific_Id">{{'SCHEME_ID'| translate}}
                            <p-columnFilter type="text" field="Scheme_Specific_Id" display="menu"></p-columnFilter>
                            <p-sortIcon field="Scheme_Specific_Id"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Farmer_Name_In_English">{{'FARMER_NAME'| translate}}
                            <p-columnFilter type="text" field="Farmer_Name_In_English" display="menu"></p-columnFilter>
                            <p-sortIcon field="Farmer_Name_In_English"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Gender">{{'GENDER'| translate}}
                            <p-columnFilter type="text" field="Gender" display="menu"></p-columnFilter>
                            <p-sortIcon field="Gender"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Caste_Description">{{'CASTE'| translate}}
                            <p-columnFilter type="text" field="Caste_Description" display="menu"></p-columnFilter>
                            <p-sortIcon field="Caste_Description"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Address_Line_1">{{'ADDRESS_LINE_1'| translate}}
                            <p-columnFilter type="text" field="Address_Line_1" display="menu"></p-columnFilter>
                            <p-sortIcon field="Address_Line_1"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Address_Line_2">{{'ADDRESS_LINE_2'| translate}}
                            <p-columnFilter type="text" field="Address_Line_2" display="menu"></p-columnFilter>
                            <p-sortIcon field="Address_Line_2"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Address_Line_3">{{'ADDRESS_LINE_3'| translate}}
                            <p-columnFilter type="text" field="Address_Line_3" display="menu"></p-columnFilter>
                            <p-sortIcon field="Address_Line_3"></p-sortIcon>
                        </th>

                        <th pSortableColumn="District">{{'DISTRICT'| translate}}
                            <p-columnFilter type="text" field="District" display="menu"></p-columnFilter>
                            <p-sortIcon field="District"></p-sortIcon>
                        </th>

                        <th pSortableColumn="State">{{'STATE'| translate}}
                            <p-columnFilter type="text" field="State" display="menu"></p-columnFilter>
                            <p-sortIcon field="State"></p-sortIcon>
                        </th>



                        <th pSortableColumn="Country">{{'COUNTRY'| translate}}
                            <p-columnFilter type="text" field="Country" display="menu"></p-columnFilter>
                            <p-sortIcon field="Country"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Farmer_Bank_Name">{{'FARMER_BANK_NAME'| translate}}
                            <p-columnFilter type="text" field="Farmer_Bank_Name" display="menu"></p-columnFilter>
                            <p-sortIcon field="Farmer_Bank_Name"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Farmer_IFSCCode">{{'FARMER_IFSC_CODE'| translate}}
                            <p-columnFilter type="text" field="Farmer_IFSCCode" display="menu"></p-columnFilter>
                            <p-sortIcon field="Farmer_IFSCCode"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Farmer_Account_Number">{{'FAMER_ACCOUNT_NUMBER'| translate}}
                            <p-columnFilter type="text" field="Farmer_Account_Number" display="menu"></p-columnFilter>
                            <p-sortIcon field="Farmer_Account_Number"></p-sortIcon>
                        </th>

                        <th pSortableColumn="Aadhar_Number">{{'AADHAR_NUMBER'| translate}}
                            <p-columnFilter type="text" field="Aadhar_Number" display="menu"></p-columnFilter>
                            <p-sortIcon field="Aadhar_Number"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Pincode">{{'PINCODE'| translate}}
                            <p-columnFilter type="text" field="Pincode" display="menu"></p-columnFilter>
                            <p-sortIcon field="Pincode"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Center_Share_Payment_Amount">{{'CENTER_SHARE_PAYMENT'| translate}}
                            <p-columnFilter type="text" field="Center_Share_Payment_Amount" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="Center_Share_Payment_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="State_Share_Payment_Amount">{{'STATE_SHARE_PAYMENT'| translate}}
                            <p-columnFilter type="text" field="State_Share_Payment_Amount" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="State_Share_Payment_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="ABY">{{'ABY'| translate}}
                            <p-columnFilter type="text" field="ABY" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="State_Share_Payment_Amount"></p-sortIcon>
                        </th>
                        <th pSortableColumn="TopUp">{{'TOP_UP'| translate}}
                            <p-columnFilter type="text" field="TopUp" display="menu">
                            </p-columnFilter>
                            <p-sortIcon field="TopUp"></p-sortIcon>
                        </th>
                        <!-- <th pSortableColumn="ActualSubsidy_Stage1">ActualSubsidy Stage1
                            <p-columnFilter type="text" field="ActualSubsidy_Stage1" display="menu"></p-columnFilter>
                            <p-sortIcon field="ActualSubsidy_Stage1"></p-sortIcon>
                        </th> -->
                        <th pSortableColumn="ApplicantType">{{'APPLICATION_TYPE'| translate}}
                            <p-columnFilter type="text" field="ApplicantType" display="menu"></p-columnFilter>
                            <p-sortIcon field="ApplicantType"></p-sortIcon>
                        </th>
                        <th pSortableColumn="UserType">{{'USER_TYPE'| translate}}
                            <p-columnFilter type="text" field="UserType" display="menu"></p-columnFilter>
                            <p-sortIcon field="UserType"></p-sortIcon>
                        </th>
                        <th pSortableColumn="Coverage_Area">{{'COVERAGE_AREA'| translate}}
                            <p-columnFilter type="text" field="Coverage_Area" display="menu"></p-columnFilter>
                            <p-sortIcon field="Coverage_Area"></p-sortIcon>
                        </th>
                        <th pSortableColumn="FinYear">{{'FINANCIAL_YEAR'| translate}}
                            <p-columnFilter type="text" field="FinYear" display="menu"></p-columnFilter>
                            <p-sortIcon field="FinYear"></p-sortIcon>
                        </th>
                    </tr>

                </ng-template>

                <ng-template pTemplate="body" let-product let-rowIndex="rowIndex">
                    <tr>
                        <td>
                            <p-tableCheckbox [value]="product"></p-tableCheckbox>
                        </td>
                        <td>
                            <button pButton pRipple pTooltip="view application" icon="pi pi-file"
                                class="p-button-rounded p-button-accent mr-1 btnSize"
                                (click)="selectFarmerApplication(product)"></button>
                        </td>
                        <!-- <td>{{rowIndex + 1}}</td> -->
                        <td>{{product?.Scheme_Specific_Id}}</td>
                        <td>{{product?.Farmer_Name_In_English}}</td>
                        <td>{{product?.Gender}}</td>
                        <td>{{product?.Caste_Description}}</td>
                        <td>{{product?.Address_Line_1}}</td>
                        <td>{{product?.Address_Line_2}}</td>
                        <td>{{product?.Address_Line_3}}</td>
                        <td>{{product?.District}}</td>
                        <td>{{product?.State}}</td>
                        <td>{{product?.Country}}</td>
                        <td>{{product?.Farmer_Bank_Name}}</td>
                        <td>{{product?.Farmer_IFSCCode}}</td>
                        <td>{{product?.Farmer_Account_Number}}</td>
                        <td>{{product?.Aadhar_Number}}</td>
                        <td>{{product?.Pincode}}</td>
                        <td>{{product?.Center_Share_Payment_Amount}}</td>
                        <td>{{product?.State_Share_Payment_Amount}}</td>
                        <td>{{product?.ABY}}</td>
                        <td>{{product?.TopUp}}</td>
                        <!-- <td>{{product?.ActualSubsidy_Stage1}}</td> -->
                        <td>{{product.ApplicantType}}</td>
                        <td>{{product.UserType}}</td>
                        <td>{{product.Coverage_Area}}</td>
                        <td>{{product.FinYear}}</td>
                    </tr>
                </ng-template>

            </p-table>
        </div>
        <div class="card" *ngIf="filteredData.length">
            <h5><b>{{'TOTAL_NO_OF_APPLICATION_POND_TANK_STAGE-1'| translate}}: {{ totalSelectedApp }}</b></h5>
            <div class="flex justify-content-end">
                <button (click)="menu.toggle($event)" pButton pRipple p-button-info label="Download Filtered Lot Data"
                    icon="pi pi-upload"></button>
                <p-menu #menu [popup]="true" [model]="appVerificationItems"></p-menu>
            </div>


            <div class="card">
                <p-toolbar *ngIf="filteredData.length">
                    <ng-template pTemplate="left">

                    </ng-template>
                    <ng-template pTemplate="right">
                        <p-dropdown [options]="items" [(ngModel)]="selectedStatus" optionLabel="status" class="mr-3">
                        </p-dropdown>
                        <textarea id="description" [(ngModel)]="remarks" placeholder="{{'REMARKS'| translate}}" pInputTextarea required
                            rows="3" cols="20" class="mr-3"></textarea>
                        <button pButton pRipple label="{{'SUBMIT'| translate}}" (click)="handleClick()" class="p-button-help"></button>
                    </ng-template>
                </p-toolbar>
            </div>
        </div>
    </p-card>
</div>